import { SUBCLUSTERS } from '../subclusters.js';

const PMO_CLUSTER = {
    subclusters: [
        {
            key: SUBCLUSTERS.PROJECT_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.PROJECT_PLANNING,
        },
        {
            key: SUBCLUSTERS.CUSTOMER_PROJECTS,
        },
        {
            key: SUBCLUSTERS.TASKS,
        },
        {
            key: SUBCLUSTERS.MANAGING_PROJECTS_PORTFOLIO,
        },
        {
            key: SUBCLUSTERS.MANAGING_ROUTINE_PROCESSES,
        },
        {
            key: SUBCLUSTERS.RESOURCE_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.REPORTING_TO_EXECUTIVES,
        },
        {
            key: SUBCLUSTERS.CLIENT_PROJECTS,
        },
        {
            key: SUBCLUSTERS.CRM,
        },
        {
            key: SUBCLUSTERS.SOFTWARE_DEVELOPMENT,
        },
    ],
};

export { PMO_CLUSTER };
